import Container from "../../shared/ui/Container";
import "./Terms.scss";

export default function Terms() {
  return (
    <div className="terms">
      <section className="page-header" aria-labelledby="page-title">
        <Container>
          <h1 className="page-header__title">Terms of Service</h1>
          <p className="page-header__subtitle">Last updated: 17.11.2025</p>
        </Container>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">1. Acceptance of Terms</h2>
        <p className="terms-section__text">
          By accessing or using our website, you confirm that you are at least
          18 years old and agree to comply with these Terms. If you do not
          agree, please do not use this website.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">2. Use of the Website</h2>
        <p className="terms-section__text">You agree not to:</p>

        <ul className="terms-section__list">
          <li className="terms-section__list-item">
            use the website for any illegal or unauthorized purpose,
          </li>
          <li className="terms-section__list-item">
            attempt to gain unauthorized access,
          </li>
          <li className="terms-section__list-item">
            disrupt or interfere with functionality.
          </li>
          <li className="terms-section__list-item">
            attempt to access server data, databases, or systems without
            permission.
          </li>
          <li className="terms-section__list-item">
            send spam, harmful code, or malicious content through our form.
          </li>
        </ul>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">3. Services Provided</h2>
        <p className="terms-section__text">
          All information on this website is for general informational purposes
          only and does not constitute legal, financial, or professional advice.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">4. User Responsibilities</h2>
        <p className="terms-section__text">
          When submitting the contact form, you agree that your information is
          accurate and lawful. By submitting the form, you agree that: You
          provide information voluntarily. You may receive an automatic email
          reply. We may contact you using the information you provided. We do
          not guarantee that messages sent through the form will always be
          received or answered.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">5. Intellectual Property</h2>
        <p className="terms-section__text">
          All content on this website is owned by us unless stated otherwise.
          You may not reproduce or redistribute it without permission.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">6. Third-Party Services</h2>
        <p className="terms-section__text">
          We may use third-party providers such as Microsoft, MongoDB Atlas, and
          Contentful. These services have their own terms and privacy policies.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">7. Limitation of Liability</h2>
        <p className="terms-section__text">
          We are not liable for disruptions, errors, data loss,technical
          problems, damages or reliance on website content.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">8. No Warranty</h2>
        <p className="terms-section__text">
          The website is provided "as is" without any warranties of accuracy or
          availability.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">9. No Professional Advice</h2>
        <p className="terms-section__text">
          The content on this Website is for informational purposes only. It
          should not be considered professional, legal, financial, or technical
          advice.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">10. Governing Law</h2>
        <p className="terms-section__text">
          These Terms are governed by the laws of Alberta, Canada.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">11. Changes to These Terms</h2>
        <p className="terms-section__text">
          We may update these Terms. Changes will be posted on this page.
        </p>
      </section>

      <section className="terms-section" aria-labelledby="terms-section-title">
        <h2 className="terms-section__title">12. Contact Us</h2>
        <p className="terms-section__text">
          For questions regarding these Terms, contact:{" "}
          <strong>[contactus@dafi.ca]</strong>
        </p>
      </section>
    </div>
  );
}
